import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Provider } from "unstated";

import config from "./shards-pro/config.json";

import Index from "./routes/Index";
import ElementsPage from "./components/ElementsPage";
import withTracker from "./withTracker";

import "./app.css";

class App extends Component {
  
  render() {
    return (
      <Provider>
        <Router basename={ process.env.REACT_APP_BASENAME_PREFIX }>
          <Route key={0} path="/" exact component={withTracker(props => <Index {...props} />)} />
          {config.categories.map((category, index) => {
            const DynamicElementsPage = (props) => <ElementsPage categoryIdx={index} {...props} />;
            return (
              <Route
                key={index}
                path={"/" + category.path}
                component={withTracker(props => {
                  return <DynamicElementsPage {...props} />
                })}
              />
            );
          })}
        </Router>
      </Provider>
    );
  }
}

export default App;
